import { MapperBase } from '../../utilities/mapper-base';
import { ProductionJobSharedDetailResource } from '../resource/production-job-shared-detail.resource';
import { ProductionJobSharedDetail } from '../ui/production-job-shared-detail.model';

export class ProductionJobSharedDetailResourceToProductionJobSharedDetailMapper extends MapperBase<ProductionJobSharedDetailResource, ProductionJobSharedDetail> {
	map(source: ProductionJobSharedDetailResource): ProductionJobSharedDetail {
		const dest = new ProductionJobSharedDetail();
		dest.sharedId = source?.sharedId;
		dest.title = source?.title;
		dest.docSizeProduced = source?.docSizeProduced;
		dest.hasPassword = source?.hasPassword;
		dest.jobStatus = source?.jobStatus;
		dest.productionJobId = source?.productionJobId;
		dest.caseId = source?.caseId;
		return dest;
	}

}

